import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'

import { StatsBlock } from '../common/stats-block'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  children: React.ReactNode
  onClick?: () => void
} & ClassNameProps

export const DistributionCommon = (props: Props) => {
  const { t } = useTranslation()
  return (
    <StatsBlock
      onClick={props.onClick}
      className={props.className}
      header={
        <StatsBlock.Header>
          <StatsBlock.Title>{t('profile.distribution')}</StatsBlock.Title>
          <HeaderValue>
            {t('common.count')}&nbsp;<HeaderSeparator>/</HeaderSeparator>&nbsp;%
          </HeaderValue>
        </StatsBlock.Header>
      }
    >
      {props.children}
    </StatsBlock>
  )
}

const HeaderValue = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: var(--text-11);
`
const HeaderSeparator = styled.span`
  color: var(--text-9);
`
